// extracted by mini-css-extract-plugin
module.exports = {"footerIconLink":"az_sxb"};